import React from "react";
import { targets } from "../../data/impactStories";
import { CheckCircle2, TrendingUp, CalendarClock, Eye, AlertCircle } from "lucide-react";

const statusConfig = {
  Completed: { icon: CheckCircle2, cls: "bg-[#F5D000] text-black border-[#F5D000]" },
  "On Track": { icon: TrendingUp, cls: "bg-[#F5D000]/12 text-[#F5D000] border-[#F5D000]/40" },
  Planned: { icon: CalendarClock, cls: "bg-white/5 text-white/60 border-white/15" },
  Monitoring: { icon: Eye, cls: "bg-white/5 text-white/80 border-white/30" },
  "Awaiting Verification": { icon: AlertCircle, cls: "bg-white/5 text-white/55 border-dashed border-white/25" }
};

export default function RiTargets() {
  return (
    <section id="targets" data-testid="ri-targets" className="py-24 lg:py-32 bg-[#08080a] scroll-mt-20">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-14 reveal">
          <div className="text-[11px] uppercase tracking-[0.3em] text-amber-accent mb-4">Our Targets</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.02]">
            Where we're headed, <span className="text-amber-accent">plainly stated.</span>
          </h2>
          <p className="mt-5 text-white/65 leading-relaxed">
            No percentages plucked from thin air. Each target carries an honest status,
            and moves only when the evidence does.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {targets.map((t, i) => {
            const cfg = statusConfig[t.status];
            const Icon = cfg.icon;
            return (
              <div
                key={t.id}
                data-testid={`target-${t.id}`}
                className="reveal rounded-2xl bg-[#101014] border border-white/8 hover:border-[#F5D000]/40 transition-all p-6 flex items-start gap-5"
                style={{ transitionDelay: `${i * 50}ms` }}
              >
                <div className="min-w-0 flex-1">
                  <div className="text-[10px] uppercase tracking-[0.22em] text-[#F5D000] font-semibold mb-1.5">{t.pillar} · due {t.due}</div>
                  <h3 className="font-display text-lg font-bold text-white leading-snug mb-1.5">{t.title}</h3>
                  <p className="text-sm text-white/55 leading-relaxed">{t.detail}</p>
                </div>
                <span className={`shrink-0 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-[10px] uppercase tracking-[0.14em] font-bold whitespace-nowrap ${cfg.cls}`}>
                  <Icon className="w-3.5 h-3.5" /> {t.status}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
